import { SyntheticEvent } from 'react';

export const trackEvent = (category: string, action: string, label: string | number | null) => {
  window.dataLayer.push({
    event: 'trackEvent',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
  });
};

const createTrackLinkEvent = (type: string) => (e: SyntheticEvent) => {
  const url = e.currentTarget.getAttribute('href');
  trackEvent(type, 'link', url);
};

export const trackExternalLinkEvent = createTrackLinkEvent('external');

export const trackInternalLinkEvent = createTrackLinkEvent('internal');
